import { emptySplitApi as api } from "./emptyApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    postApiV1AppConfiguration: build.mutation<
      PostApiV1AppConfigurationApiResponse,
      PostApiV1AppConfigurationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/appConfiguration`,
        method: "POST",
        body: queryArg.searchAppConfigurationsRequest,
      }),
    }),
    putApiV1AppConfiguration: build.mutation<
      PutApiV1AppConfigurationApiResponse,
      PutApiV1AppConfigurationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/appConfiguration`,
        method: "PUT",
        body: queryArg.updateAppConfigurationRequest,
      }),
    }),
    postApiV1ProductExport: build.mutation<
      PostApiV1ProductExportApiResponse,
      PostApiV1ProductExportApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/product/export`,
        method: "POST",
        body: queryArg.exportRequest,
      }),
    }),
    getApiV1HealthCheck: build.query<
      GetApiV1HealthCheckApiResponse,
      GetApiV1HealthCheckApiArg
    >({
      query: () => ({ url: `/api/v1/health-check` }),
    }),
    getApiV1BeHealthCheck: build.query<
      GetApiV1BeHealthCheckApiResponse,
      GetApiV1BeHealthCheckApiArg
    >({
      query: () => ({ url: `/api/v1/be-health-check` }),
    }),
    postApiV1MetadataCategory: build.mutation<
      PostApiV1MetadataCategoryApiResponse,
      PostApiV1MetadataCategoryApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/metadata/category`,
        method: "POST",
        body: queryArg.searchMetadataCategoriesRequest,
      }),
    }),
    postApiV1Metadata: build.mutation<
      PostApiV1MetadataApiResponse,
      PostApiV1MetadataApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/metadata`,
        method: "POST",
        body: queryArg.searchMetadataRequest,
      }),
    }),
    putApiV1Metadata: build.mutation<
      PutApiV1MetadataApiResponse,
      PutApiV1MetadataApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/metadata`,
        method: "PUT",
        body: queryArg.updateMetadataRequest,
      }),
    }),
    deleteApiV1Metadata: build.mutation<
      DeleteApiV1MetadataApiResponse,
      DeleteApiV1MetadataApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/metadata`,
        method: "DELETE",
        body: queryArg.deleteMetadataRequest,
      }),
    }),
    postApiV1MonitoringProductPropertyByCategory: build.mutation<
      PostApiV1MonitoringProductPropertyByCategoryApiResponse,
      PostApiV1MonitoringProductPropertyByCategoryApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/monitoring/product-property-by-category`,
        method: "POST",
        body: queryArg.monitoringProductPropertyCategoryChartRequest,
      }),
    }),
    postApiV1MonitoringProductByMonth: build.mutation<
      PostApiV1MonitoringProductByMonthApiResponse,
      PostApiV1MonitoringProductByMonthApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/monitoring/product-by-month`,
        method: "POST",
        body: queryArg.monitoringProductMonthChartRequest,
      }),
    }),
    getApiV1Product: build.query<
      GetApiV1ProductApiResponse,
      GetApiV1ProductApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/product`,
        params: { productId: queryArg.productId },
      }),
    }),
    putApiV1Product: build.mutation<
      PutApiV1ProductApiResponse,
      PutApiV1ProductApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/product`,
        method: "PUT",
        body: queryArg.uploadProductRequest,
      }),
    }),
    deleteApiV1Product: build.mutation<
      DeleteApiV1ProductApiResponse,
      DeleteApiV1ProductApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/product`,
        method: "DELETE",
        body: queryArg.deleteProductRequest,
      }),
    }),
    postApiV1Product: build.mutation<
      PostApiV1ProductApiResponse,
      PostApiV1ProductApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/product`,
        method: "POST",
        body: queryArg.searchProductsRequest,
      }),
    }),
    postApiV1ProductRollingRelease: build.mutation<
      PostApiV1ProductRollingReleaseApiResponse,
      PostApiV1ProductRollingReleaseApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/product/rolling-release`,
        method: "POST",
        body: queryArg.searchRollingReleaseRequest,
      }),
    }),
    postApiV1ProductPropertyFilter: build.mutation<
      PostApiV1ProductPropertyFilterApiResponse,
      PostApiV1ProductPropertyFilterApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/product/property/filter`,
        method: "POST",
        body: queryArg.searchProductPropertyFiltersRequest,
      }),
    }),
    patchApiV1UserPassword: build.mutation<
      PatchApiV1UserPasswordApiResponse,
      PatchApiV1UserPasswordApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/user/password`,
        method: "PATCH",
        body: queryArg.resetUserPasswordRequest,
      }),
    }),
    deleteApiV1User: build.mutation<
      DeleteApiV1UserApiResponse,
      DeleteApiV1UserApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/user`,
        method: "DELETE",
        body: queryArg.deleteUserRequest,
      }),
    }),
    postApiV1User: build.mutation<
      PostApiV1UserApiResponse,
      PostApiV1UserApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/user`,
        method: "POST",
        body: queryArg.searchUsersRequest,
      }),
    }),
    putApiV1User: build.mutation<PutApiV1UserApiResponse, PutApiV1UserApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/user`,
        method: "PUT",
        body: queryArg.updateUserRequest,
      }),
    }),
    getApiV1UserMe: build.query<
      GetApiV1UserMeApiResponse,
      GetApiV1UserMeApiArg
    >({
      query: () => ({ url: `/api/v1/user/me` }),
    }),
    putApiV1UserMe: build.mutation<
      PutApiV1UserMeApiResponse,
      PutApiV1UserMeApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/user/me`,
        method: "PUT",
        body: queryArg.updateMeRequest,
      }),
    }),
    postApiV1Login: build.mutation<
      PostApiV1LoginApiResponse,
      PostApiV1LoginApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/login`,
        method: "POST",
        body: queryArg.loginRequest,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as governanceToolApi };
export type PostApiV1AppConfigurationApiResponse =
  /** status 200 Success */ SearchAppConfigurationsResponseServiceResponse;
export type PostApiV1AppConfigurationApiArg = {
  searchAppConfigurationsRequest: SearchAppConfigurationsRequest;
};
export type PutApiV1AppConfigurationApiResponse =
  /** status 200 Success */ UpdateAppConfigurationResponseServiceResponse;
export type PutApiV1AppConfigurationApiArg = {
  updateAppConfigurationRequest: UpdateAppConfigurationRequest;
};
export type PostApiV1ProductExportApiResponse = unknown;
export type PostApiV1ProductExportApiArg = {
  exportRequest: ExportRequest;
};
export type GetApiV1HealthCheckApiResponse = unknown;
export type GetApiV1HealthCheckApiArg = void;
export type GetApiV1BeHealthCheckApiResponse =
  /** status 200 Success */ HealthCheckResponseServiceResponse;
export type GetApiV1BeHealthCheckApiArg = void;
export type PostApiV1MetadataCategoryApiResponse =
  /** status 200 Success */ SearchMetadataCategoriesResponseServiceResponse;
export type PostApiV1MetadataCategoryApiArg = {
  searchMetadataCategoriesRequest: SearchMetadataCategoriesRequest;
};
export type PostApiV1MetadataApiResponse =
  /** status 200 Success */ SearchMetadataResponseServiceResponse;
export type PostApiV1MetadataApiArg = {
  searchMetadataRequest: SearchMetadataRequest;
};
export type PutApiV1MetadataApiResponse =
  /** status 200 Success */ UpdateMetadataResponseServiceResponse;
export type PutApiV1MetadataApiArg = {
  updateMetadataRequest: UpdateMetadataRequest;
};
export type DeleteApiV1MetadataApiResponse =
  /** status 200 Success */ DeleteMetadataResponseServiceResponse;
export type DeleteApiV1MetadataApiArg = {
  deleteMetadataRequest: DeleteMetadataRequest;
};
export type PostApiV1MonitoringProductPropertyByCategoryApiResponse =
  /** status 200 Success */ MonitoringProductPropertyCategoryChartResponseServiceResponse;
export type PostApiV1MonitoringProductPropertyByCategoryApiArg = {
  monitoringProductPropertyCategoryChartRequest: MonitoringProductPropertyCategoryChartRequest;
};
export type PostApiV1MonitoringProductByMonthApiResponse =
  /** status 200 Success */ MonitoringProductMonthChartResponseServiceResponse;
export type PostApiV1MonitoringProductByMonthApiArg = {
  monitoringProductMonthChartRequest: MonitoringProductMonthChartRequest;
};
export type GetApiV1ProductApiResponse =
  /** status 200 Success */ GetProductResponseServiceResponse;
export type GetApiV1ProductApiArg = {
  productId?: string;
};
export type PutApiV1ProductApiResponse =
  /** status 200 Success */ UploadProductResponseServiceResponse;
export type PutApiV1ProductApiArg = {
  uploadProductRequest: UploadProductRequest;
};
export type DeleteApiV1ProductApiResponse =
  /** status 200 Success */ UploadProductResponseServiceResponse;
export type DeleteApiV1ProductApiArg = {
  deleteProductRequest: DeleteProductRequest;
};
export type PostApiV1ProductApiResponse =
  /** status 200 Success */ SearchProductsResponseServiceResponse;
export type PostApiV1ProductApiArg = {
  searchProductsRequest: SearchProductsRequest;
};
export type PostApiV1ProductRollingReleaseApiResponse =
  /** status 200 Success */ SearchRollingReleaseResponseServiceResponse;
export type PostApiV1ProductRollingReleaseApiArg = {
  searchRollingReleaseRequest: SearchRollingReleaseRequest;
};
export type PostApiV1ProductPropertyFilterApiResponse =
  /** status 200 Success */ SearchProductPropertyFiltersResponseServiceResponse;
export type PostApiV1ProductPropertyFilterApiArg = {
  searchProductPropertyFiltersRequest: SearchProductPropertyFiltersRequest;
};
export type PatchApiV1UserPasswordApiResponse =
  /** status 200 Success */ ResetUserPasswordResponseServiceResponse;
export type PatchApiV1UserPasswordApiArg = {
  resetUserPasswordRequest: ResetUserPasswordRequest;
};
export type DeleteApiV1UserApiResponse =
  /** status 200 Success */ DeleteUserResponseServiceResponse;
export type DeleteApiV1UserApiArg = {
  deleteUserRequest: DeleteUserRequest;
};
export type PostApiV1UserApiResponse =
  /** status 200 Success */ SearchUsersResponseServiceResponse;
export type PostApiV1UserApiArg = {
  searchUsersRequest: SearchUsersRequest;
};
export type PutApiV1UserApiResponse =
  /** status 200 Success */ UpdateUserResponseServiceResponse;
export type PutApiV1UserApiArg = {
  updateUserRequest: UpdateUserRequest;
};
export type GetApiV1UserMeApiResponse =
  /** status 200 Success */ GetUserResponseServiceResponse;
export type GetApiV1UserMeApiArg = void;
export type PutApiV1UserMeApiResponse =
  /** status 200 Success */ UpdateMeResponseServiceResponse;
export type PutApiV1UserMeApiArg = {
  updateMeRequest: UpdateMeRequest;
};
export type PostApiV1LoginApiResponse =
  /** status 200 Success */ LoginResponseServiceResponse;
export type PostApiV1LoginApiArg = {
  loginRequest: LoginRequest;
};
export type AppConfigurationData = {
  id: string;
  value?: string | null;
  updated: number;
  updater: string;
};
export type SearchAppConfigurationsResponse = {
  configurations?: AppConfigurationData[] | null;
};
export type SearchAppConfigurationsResponseServiceResponse = {
  payload?: SearchAppConfigurationsResponse;
  error?: number | null;
};
export type SearchAppConfigurationsRequest = {
  page?: number | null;
  pageSize?: number | null;
};
export type UpdateAppConfigurationResponse = object;
export type UpdateAppConfigurationResponseServiceResponse = {
  payload?: UpdateAppConfigurationResponse;
  error?: number | null;
};
export type UpdateAppConfigurationRequest = {
  configurations?: AppConfigurationData[] | null;
};
export type ReleaseType = 0 | 1;
export type ExportRequest = {
  search?: string | null;
  productPropertyFilterIds?: string[] | null;
  releaseType?: ReleaseType;
};
export type HealthCheckStatus = 10 | 50 | 90;
export type EnabledLogLevel = {
  error?: boolean;
  warning?: boolean;
  debug?: boolean;
  information?: boolean;
};
export type HealthCheckResponse = {
  dbConnection?: HealthCheckStatus;
  existMigrations?: HealthCheckStatus;
  migrationsFolder?: string[] | null;
  migrationExtension?: string | null;
  existPrivateKey?: HealthCheckStatus;
  existAuthenticationPrivateKey?: HealthCheckStatus;
  existAuthenticationPublicKey?: HealthCheckStatus;
  enabledLogLevel?: EnabledLogLevel;
  storeSign?: string | null;
};
export type HealthCheckResponseServiceResponse = {
  payload?: HealthCheckResponse;
  error?: number | null;
};
export type MetadataCategoryData = {
  code?: string | null;
  enabled?: boolean;
  inserted?: number;
  updated?: number;
};
export type SearchMetadataCategoriesResponse = {
  metadataCategories?: MetadataCategoryData[] | null;
};
export type SearchMetadataCategoriesResponseServiceResponse = {
  payload?: SearchMetadataCategoriesResponse;
  error?: number | null;
};
export type SearchMetadataCategoriesRequest = {
  page?: number | null;
  pageSize?: number | null;
};
export type MetadataData = {
  id: string;
  category?: string | null;
  value?: string | null;
  enabled: boolean;
  inserted: number;
  updated: number;
  updater: string;
};
export type SearchMetadataResponse = {
  metadata?: MetadataData[] | null;
  count?: number;
};
export type SearchMetadataResponseServiceResponse = {
  payload?: SearchMetadataResponse;
  error?: number | null;
};
export type SearchMetadataRequest = {
  page?: number | null;
  pageSize?: number | null;
  metadataId?: string | null;
  category?: string | null;
  search?: string | null;
  returnOnlyIds?: boolean;
};
export type UpdateMetadataResponse = object;
export type UpdateMetadataResponseServiceResponse = {
  payload?: UpdateMetadataResponse;
  error?: number | null;
};
export type UpdateMetadataRequest = {
  metadataId?: string | null;
  category?: string | null;
  value?: string | null;
};
export type DeleteMetadataResponse = object;
export type DeleteMetadataResponseServiceResponse = {
  payload?: DeleteMetadataResponse;
  error?: number | null;
};
export type DeleteMetadataRequest = {
  metadataId?: string | null;
};
export type ValueCounter = {
  value?: string | null;
  count?: number;
};
export type MonitoringProductPropertyCategoryChartResponse = {
  items?: ValueCounter[] | null;
};
export type MonitoringProductPropertyCategoryChartResponseServiceResponse = {
  payload?: MonitoringProductPropertyCategoryChartResponse;
  error?: number | null;
};
export type MonitoringProductPropertyCategoryChartRequest = {
  category?: string | null;
};
export type MonitoringProductMonthChartResponse = {
  items?: ValueCounter[] | null;
};
export type MonitoringProductMonthChartResponseServiceResponse = {
  payload?: MonitoringProductMonthChartResponse;
  error?: number | null;
};
export type MonitoringProductMonthChartRequest = object;
export type PropertyType = 0 | 1;
export type ProductPropertyData = {
  id: string;
  productId?: string | null;
  category?: string | null;
  value?: string | null;
  type?: PropertyType;
  enabled: boolean;
  inserted: number;
  updated: number;
  updater: string;
};
export type Product = {
  id: string;
  name: string;
  version: string;
  isStableRelease?: boolean;
  updater: string;
  updated: number;
  inserted: number;
  productProperties?: ProductPropertyData[] | null;
};
export type GetProductResponse = {
  product?: Product;
};
export type GetProductResponseServiceResponse = {
  payload?: GetProductResponse;
  error?: number | null;
};
export type UploadProductResponse = object;
export type UploadProductResponseServiceResponse = {
  payload?: UploadProductResponse;
  error?: number | null;
};
export type UploadProductProperty = {
  category?: string | null;
  value?: string | null;
};
export type UploadProductRequest = {
  name?: string | null;
  version?: string | null;
  isStableRelease?: boolean | null;
  properties?: UploadProductProperty[] | null;
  metadataIds?: string[] | null;
};
export type DeleteProductRequest = {
  productId?: string | null;
};
export type SearchProductsResponse = {
  products?: Product[] | null;
  count?: number;
};
export type SearchProductsResponseServiceResponse = {
  payload?: SearchProductsResponse;
  error?: number | null;
};
export type SearchProductsRequest = {
  page?: number | null;
  pageSize?: number | null;
  search?: string | null;
  productPropertyFilterIds?: string[] | null;
  categories?: string[] | null;
  releaseType?: ReleaseType;
  productName?: string | null;
};
export type SearchRollingReleaseResponse = {
  product?: Product;
};
export type SearchRollingReleaseResponseServiceResponse = {
  payload?: SearchRollingReleaseResponse;
  error?: number | null;
};
export type SearchRollingReleaseRequest = {
  name?: string | null;
};
export type SearchProductPropertyFiltersResponse = {
  productPropertyFilters?: ProductPropertyData[] | null;
};
export type SearchProductPropertyFiltersResponseServiceResponse = {
  payload?: SearchProductPropertyFiltersResponse;
  error?: number | null;
};
export type SearchProductPropertyFiltersRequest = {
  category?: string | null;
};
export type ResetUserPasswordResponse = {
  password?: string | null;
};
export type ResetUserPasswordResponseServiceResponse = {
  payload?: ResetUserPasswordResponse;
  error?: number | null;
};
export type ResetUserPasswordRequest = {
  username?: string | null;
  privateKey?: string | null;
};
export type DeleteUserResponse = object;
export type DeleteUserResponseServiceResponse = {
  payload?: DeleteUserResponse;
  error?: number | null;
};
export type DeleteUserRequest = {
  userId?: string | null;
};
export type UserData = {
  id: string;
  username: string;
  password: string;
  role?: string | null;
  enabled: boolean;
  inserted: number;
  updated: number;
  updater: string;
};
export type SearchUsersResponse = {
  users?: UserData[] | null;
  count?: number;
};
export type SearchUsersResponseServiceResponse = {
  payload?: SearchUsersResponse;
  error?: number | null;
};
export type SearchUsersRequest = {
  page?: number | null;
  pageSize?: number | null;
  returnOnlyIds?: boolean;
  search?: string | null;
};
export type UpdateUserResponse = {
  userId?: string | null;
};
export type UpdateUserResponseServiceResponse = {
  payload?: UpdateUserResponse;
  error?: number | null;
};
export type UpdateUserRequest = {
  userId?: string | null;
  username?: string | null;
  password?: string | null;
  role?: string | null;
};
export type GetUserResponse = {
  username?: string | null;
  role?: string | null;
};
export type GetUserResponseServiceResponse = {
  payload?: GetUserResponse;
  error?: number | null;
};
export type UpdateMeResponse = object;
export type UpdateMeResponseServiceResponse = {
  payload?: UpdateMeResponse;
  error?: number | null;
};
export type UpdateMeRequest = {
  password?: string | null;
};
export type LoginResponse = {
  token?: string | null;
  expiredAt?: number;
};
export type LoginResponseServiceResponse = {
  payload?: LoginResponse;
  error?: number | null;
};
export type LoginRequest = {
  username?: string | null;
  password?: string | null;
};
export const {
  usePostApiV1AppConfigurationMutation,
  usePutApiV1AppConfigurationMutation,
  usePostApiV1ProductExportMutation,
  useGetApiV1HealthCheckQuery,
  useGetApiV1BeHealthCheckQuery,
  usePostApiV1MetadataCategoryMutation,
  usePostApiV1MetadataMutation,
  usePutApiV1MetadataMutation,
  useDeleteApiV1MetadataMutation,
  usePostApiV1MonitoringProductPropertyByCategoryMutation,
  usePostApiV1MonitoringProductByMonthMutation,
  useGetApiV1ProductQuery,
  usePutApiV1ProductMutation,
  useDeleteApiV1ProductMutation,
  usePostApiV1ProductMutation,
  usePostApiV1ProductRollingReleaseMutation,
  usePostApiV1ProductPropertyFilterMutation,
  usePatchApiV1UserPasswordMutation,
  useDeleteApiV1UserMutation,
  usePostApiV1UserMutation,
  usePutApiV1UserMutation,
  useGetApiV1UserMeQuery,
  usePutApiV1UserMeMutation,
  usePostApiV1LoginMutation,
} = injectedRtkApi;
